/* HR tour -- 6 steps. People / attendance / onboarding focused. */
export default {
  role: "HR",
  steps: [
    {
      id: "hr-welcome",
      route: "/",
      selector: '[data-tour-id="topbar-profile"]',
      titleKey: "tour.hr.welcome.title", titleFallback: "Welcome, {name}",
      bodyKey: "tour.hr.welcome.body", bodyFallback: "Quick tour of the HR surface: employees, onboarding, attendance and leaves. ~3 minutes.",
      side: "bottom",
    },
    {
      id: "hr-employees",
      route: "/hr/employees",
      selector: '[data-tour-id="hr-employees-page"]',
      titleKey: "tour.hr.employees.title", titleFallback: "Employees directory",
      bodyKey: "tour.hr.employees.body", bodyFallback: "Add people, send invites, edit records and view lifecycle events. Bulk-import via CSV supported.",
      side: "top",
      optional: true,
    },
    {
      id: "hr-onboarding",
      route: "/hr/onboarding",
      selector: '[data-tour-id="hr-onboarding-page"]',
      titleKey: "tour.hr.onboarding.title", titleFallback: "Onboarding pipeline",
      bodyKey: "tour.hr.onboarding.body", bodyFallback: "See every joiner's checklist progress. Start, pause, resume or waive items as needed.",
      side: "top",
      optional: true,
    },
    {
      id: "hr-attendance",
      route: "/hr/attendance",
      selector: '[data-tour-id="attendance-page"]',
      titleKey: "tour.hr.attendance.title", titleFallback: "Live attendance",
      bodyKey: "tour.hr.attendance.body", bodyFallback: "Live board of who's in, on leave, or absent. Geofence overrides live in Rules Engine.",
      side: "top",
      optional: true,
    },
    {
      id: "hr-leaves",
      route: "/hr/leaves",
      selector: '[data-tour-id="leave-page"]',
      titleKey: "tour.hr.leaves.title", titleFallback: "Leaves queue",
      bodyKey: "tour.hr.leaves.body", bodyFallback: "Approve/reject requests. Balance auto-computed from company policy.",
      side: "top",
      optional: true,
    },
    {
      id: "hr-replay",
      route: "/",
      selector: '[data-tour-id="tour-button"]',
      titleKey: "tour.hr.replay.title", titleFallback: "Replay any time",
      bodyKey: "tour.hr.replay.body", bodyFallback: "This header button re-launches the tour whenever you need a refresher.",
      side: "bottom",
    },
  ],
};
